import React from 'react';
import styles from './MoreMenuGroup.module.scss';
import { T } from '@colonist/ui';
export const MoreMenuGroup = ({ headerText, children })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.group
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.headerText
    }, /*#__PURE__*/ React.createElement(T, {
        id: headerText
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, children));
